module.exports = require('./helpers/bundle-url').getBundleURL('duwKw') + "logo-dark.eefe0b7f.svg";